/* src/app/core/modules/shared/components/skeleton-item/skeleton-item.component.scss */
/*# sourceMappingURL=/avvera/dev/skeleton-item.component.css.map */
